export function getLastArrayObjects(array, quantity) {
	if (array.length <= quantity) {
		return array;
	}
	return array.slice(-quantity);
}